import { AliProductStatus, AutarkyStateType, CreditDataType } from '@/api/homeV2Status/types';
import { HomeThemeEnums } from '@/shared/utils/pageTheme';

/** 默认返回的都是ZHENYOUQIAN，如果在小程序中，用户下所有渠道都是拒绝的，就会返回ALIPAY */
export enum DisplayVersionEnum {
  ZHNEYOUQIAN = 'ZHNEYOUQIAN', // 臻有钱
  YINHE = 'YINHE', // 银河,
  ALIAPPLYFAILED = 'ALI_APPLET_REJECT' // 支付宝授信失败
}

export interface StateType {
  // 首页展示的广播消息
  notice: string | undefined;
  creditData: CreditDataType | null;
  // 是否需要显示数字动画
  shouldAnimate: boolean;
  categoryMaxCount: number;
  categoryLineCount: number;
  // 支付宝小程序产品状态
  aliProductStatus: AliProductStatus & {
    // 产品暂停时的首页按钮文案
    buttonText: string,
    // 产品暂停时的提示弹窗title
    dialogText: string,
    // 授信状态
    status?: string
  };
  /** 用户当前所处进度 */
  progress: string;
  /** autarkyState 用户自营状态, 是否隐藏提额入口 */
  canApplyCredit: boolean;
  /** autarkyState 用户自营状态, 用于升级判断 */
  autarkyState?: AutarkyStateType;
  /** 是否可以通过上滑的方式由无标签首页进入品质版首页 */
  canSlidInQuality: boolean;
  /** 金融卡片-营销元素高度 */
  marketHeight: string;
  /** 金融卡片-营销元素链接 */
  marketSource: string;
  /** 金融卡片-营销位是否已加载 */
  marketHasLoaded: boolean;
  /** 首页主题类型 */
  homeThemeType: HomeThemeEnums | null,
  /** 首页加载中的广告位渲染标识，用于刷新广告位(场景：临额轮询下发成功) */
  homeLoadAdvRefreshSignal: 0,
  /** 首页-右下角浮标是否显示(在组件onload监听，若广告位下发数据正常，则会置为true) */
  advHomeFloatHasVisible: boolean,
  /** 首页-预授信轮询下发标识 */
  loopQueryPreCreditIssued: boolean,
}

export enum CreditBlockedEnums {
  UPGRADE = 'upgrade',
  SUSPEND = 'suspend',
  FULL = 'full',
}
export class Home {
  hideLoading!: () => void;

  shouldCorrectRouteByCredit!: () => boolean;

  correctRouteByCredit!: () => void;

  /** 获取是否命中 老客升级页面 */
  getIsUpgradeProcessingAndCredited!: () => boolean;
}

/** 金融卡片-广告位解析的数据 */
export interface FinanceCardAnalyzeAdvData {
  /** 金融卡片-营销元素链接 */
  marketSource?: string;
  /** 金融卡片-营销元素高度 */
  marketHeight?: string;
  /** 金融卡片-营销元素宽度 */
  marketWidth?: string;
  /** 金融卡片-营销元素跳转链接 */
  marketUrl?: string;
}
